import React, { useEffect, useState, useRef } from "react";
import Card from "react-bootstrap/Card";
import { Row } from "react-bootstrap";
import a from "../Assets/whyus/1.svg";
import b from "../Assets/whyus/2.svg";
import c from "../Assets/whyus/3.svg";

import AnimationMasuk from "../animation";

const Whyus = () => {
  const rowRef = useRef(null);
  const isVisible = AnimationMasuk(rowRef);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Attach the event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [all_mat, setMatpel] = useState([]);
  useEffect(() => {
    const matpel = [
      {
        matname: "Layanan Terpadu (One-Stop Automotive Solution)",
        img: a,
        desk: "Kami menghilangkan kerumitan merawat kendaraan dengan menyediakan solusi menyeluruh dalam satu pintu. Di RPM, Anda tidak hanya mendapatkan layanan teknis, tetapi juga manajemen kendaraan yang efisien tanpa harus berpindah tempat.",
      },
      {
        matname: "Integritas & Inovasi",
        img: b,
        desk: "Berdiri sejak 2019, RPM menggabungkan pengalaman bertahun-tahun dengan teknik modern. Sebagai Konsultan Otomotif, kami bekerja secara transparan dan berbasis data, memastikan setiap tindakan—baik itu servis kecil maupun transaksi jual beli mobil bekas—dilakukan dengan standar integritas tinggi.",
      },
      {
        matname: "Berbasis Passion (High-Touch Service)",
        img: c,
        desk: "Bagi kami, setiap kendaraan mempunyai ‘rasa’ dan setiap pemilik memiliki selera yang berbeda. Kami tidak sekadar bekerja berdasarkan SOP, tetapi didorong oleh gairah otomotif untuk memberikan hasil terbaik.",
      },
    ];
    setMatpel(matpel);
  }, []);
  return (
    <Row
      id="why-us"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "100%",
        margin: "20px 20px",
        opacity: "0",
      }}
      ref={rowRef}
      className={isVisible ? "animation-fade-right" : ""}
    >
      <h3
        className="roleway"
        style={{
          textAlign: "center",
          fontSize: "60px",
          color: "#ff0000",
          padding: "0px",
        }}
      >
        Why us?
      </h3>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "100px",
          flexWrap: isMobile ? "nowrap" : "wrap",
          overflow: "hidden",
        }}
      >
        {all_mat.map((item, index) => {
          return (
            <Card
              style={{
                maxWidth: "400px",
                backgroundColor: "rgba(0,0,0,0)",
                border: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              key={index}
              className={isMobile ? "whyus-animation" : ""}
            >
              <Card.Img
                src={item.img}
                alt="Durable"
                style={{ maxWidth: "200px" }}
              />
              <Card.Body style={{ color: "#ff0000", textAlign: "center" }}>
                <Card.Title
                  className="nunito"
                  style={{
                    minHeight: "100px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    fontWeight: "bold",
                  }}
                >
                  {item.matname}
                </Card.Title>
                <Card.Text
                  className="nunito"
                  style={{ color: "white", fontSize: "19px", textAlign: "justify" }}
                >
                  {item.desk}
                </Card.Text>
              </Card.Body>
            </Card>
          );
        })}
      </Row>
    </Row>
  );
};

export default Whyus;
